var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionInput',{attrs:{"action":_vm.action,"transaction-i-d":_vm.transactionID,"draft-i-d":_vm.draftID}})
}
var staticRenderFns = []

export { render, staticRenderFns }